<ng-content></ng-content>

<nav class="flex flex-col py-2 h-full overflow-y-auto">
  <a href="https://statementzen.com/dashboard"
     class="flex items-center gap-3 px-4 py-2.5 text-sm text-neutral-700 hover:bg-neutral-100 transition-colors no-underline"
     [title]="compactMode ? 'My Account' : ''">
    <i class="fa-solid fa-gauge-high w-5 text-center text-base"></i>
    @if (!compactMode) {
      <span>My Account</span>
    }
  </a>
  @for (item of navItems; track item.path) {
    <a [routerLink]="item.path"
       routerLinkActive="bg-primary-50 text-primary-600 font-medium"
       [routerLinkActiveOptions]="{exact: item.path === '/'}"
       class="flex items-center gap-3 px-4 py-2.5 text-sm text-neutral-700 hover:bg-neutral-100 transition-colors no-underline"
       [title]="compactMode ? item.text : ''"
       (click)="onItemClick($event, item)">
      @if (item.icon) {
        <i [class]="getIconClass(item.icon)" class="w-5 text-center text-base"></i>
      }
      @if (!compactMode) {
        <span>{{ item.text }}</span>
      }
    </a>
  }
</nav>
